<template>
  <div class="ab-question warp clearfix ">
    <div class="block-title" data-aos="fade">
      {{ title }}
    </div>
    <div class="block-subtitle" data-aos="fade" data-aos-delay="100">
      {{ subTitle }}
    </div>
    <ul class="q-list" data-aos="fade-down" data-aos-delay="200">
      <li class="q-item" v-for="(item, index) in loopData" :key="index">
        <div class="q-block">
          <div class="qa-title flex-row">
            <div class="ab-point-6"></div>
            <div class="title fontsize18" v-html="item.q"></div>
          </div>
          <div class="answer fontsize18" v-html="item.a"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    blockTitle: {
      type: String,
      default: '常见问题',
    },
    blockSubTitle: {
      type: String,
      default: '来自30000+客户的信任与选择',
    },
    listData: {
      type: Array,
      default: [
        {
          q: '海关数据为什么只能点击一次，为什么很多都搜不到？',
          a:
            '我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限。',
        },
        {
          q: '海关数据为什么只能点击一次，为什么很多都搜不到？',
          a:
            '我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限。',
        },
        {
          q: '海关数据为什么只能点击一次，为什么很多都搜不到？',
          a:
            '我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限。',
        },
        {
          q: '海关数据为什么只能点击一次，为什么很多都搜不到？',
          a:
            '我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限，如想体验更多功能和数据您可以联系在线客服留下您的手机号码，这边安排业务经理给您做远程演示。我们海关数据分为免费版和收费版，数据库和功能都是不同的，免费版每天的查询数量有限。',
        },
      ],
    },
  },
  data() {
    return {
      loopData: this.listData,
      title: this.blockTitle,
      subTitle: this.blockSubTitle,
      constants: {},
    };
  },
};
</script>

<style lang="sass" scoped>

.ab-question{
  padding-top: 60px;

  .block-title{
    // width: 355px;
    height: 55px;
    font-size: 40px;
    // color: #FFFFFF;
    line-height: 55px;
    text-align: center;
  }

  .block-subtitle{
    // width: 178px;
    text-align: center;
    padding-top: 10px;
    height: 27px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R;
    font-weight: normal;
    // color: #FFFFFF;
    line-height: 27px;
    opacity: 0.4;
  }

  .q-list{
    margin: 40px -10px 0px -10px;
    float: left;
    padding-bottom: 40px;
    .q-item:hover .q-block{
     box-shadow: 0 0.21333rem 0.42667rem 0 rgb(43 104 255 / 30%);
    border: 0.02667rem solid #198BFF;
    }
    .q-item{
      float: left;
      width: 50%;
      .q-block{
        border-radius: 8px;
        margin:10px;
        height: 330px;
            background-color: rgba(249, 251, 255, 1);
        border: 1px solid rgba(220, 230, 255, 1);
        padding: 53px 41px 52px 42px;
      }

      .title{
        // height: 25px;
        font-family: AlibabaPuHuiTiM;
        color: #2B68FF;
        // line-height: 25px;
        // width: 426px;
        height: 25px;
        font-size: 18px;
        // font-family: AlibabaPuHuiTiM;
        // color: #2B68FF;
        // line-height: 25px;
      }

      .answer{

        padding-left: 16px;
        padding-top: 20px;
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-R;
        font-weight: normal;
        color: #666;
        line-height: 30px;
      }
    }
  }

}
</style>
